import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { getOffsetDate, isToday } from "./util/getOffsetTimeHelpers";
import { useBEM } from "@geome/react-next";
export const OpenNow = ({ openStatus, nextOpenStatusChange, configPath, tzOffset = 0, }) => {
    const { translate } = useI18n();
    const openNowTranslationToken = useMemo(() => {
        if (nextOpenStatusChange && openStatus !== "twenty_four_hour") {
            if (isToday(getOffsetDate(nextOpenStatusChange, tzOffset), tzOffset)) {
                return `${configPath}open_status.open_now_until_today`;
            }
            else {
                return `${configPath}open_status.open_now_until_later`;
            }
        }
        return `${configPath}open_status.open_now`;
    }, [openStatus, nextOpenStatusChange, tzOffset, configPath]);
    const className = useBEM({
        block: "open-now",
        modifiers: { "is-open": openStatus === "open" || openStatus === "twenty_four_hour" },
    });
    return (_jsx("span", { className: className, "data-testid": "open-now", children: translate(openNowTranslationToken, {
            openStatus,
            until: nextOpenStatusChange ? getOffsetDate(nextOpenStatusChange, tzOffset) : 0,
        }) }));
};
